import { render, staticRenderFns } from "./cooperation.vue?vue&type=template&id=76629386&"
import script from "./cooperation.vue?vue&type=script&lang=ts&"
export * from "./cooperation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports